export const ABSENCE_CATEGORY = 'ABSENCE'
export const OTHER_CATEGORY = 'OTHER'
export const UNJUSTIFIED = 'UNJUSTIFIED'
export const INTEGRATION = 'INTEGRATION'
export const SUPERVISION = 'SUPERVISION'
export const OFF = 'OFF'
export const SCHOOL = 'SCHOOL'

export const NOT_IN_INSTITUTION_TYPES = [UNJUSTIFIED, ABSENCE_CATEGORY, INTEGRATION, SCHOOL]
